import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Provider } from 'src/app/core/models/provider';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { ProviderService } from 'src/app/core/services/provider.service';

@Component({
  selector: 'app-search-provider',
  templateUrl: './search-provider.component.html',
  styleUrls: ['./search-provider.component.scss']
})
export class SearchProviderComponent {
  public loading = true;
  public initialLoading = true;
  public providersList!: Array<Provider>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'provider_number', direction: 'asc' },
    'providers'
  );

  public sortColumns = [
    'ahfoz_number',
    'provider_name',
    'provider_type',
    'details',
    'street_address',
    'city',
    'country',
    'phone_number',
    'email',
    'bank_name',
    'bank_code',
    'bank_branch',
    'bank_account_name',
    'bank_account_number',
    'tax_certificate_number',
  ];


  constructor(
    private router: Router,
    private providerService: ProviderService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.providerService
      .search(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.providersList = res.data.map((u) => new Provider(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(provider: Provider) {
    this.activeModal.close(provider);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
